import React, { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import AnalysisGate from '../ContentTab/AnalysisGate';
import { AgentEvalContext } from './AgentEvalProvider';
import CheckEditor from './CheckEditor';
import EvalDetail, { EvalDetailEmpty } from './EvalDetail';
import EvalList from './EvalList';

// Evaluations: the list on the left, one check's detail on the right. Selection
// lives in the URL so a result is linkable.
//
// This is the screen's landing page, so the list must not wait on anything. The
// analysis gate (every gadget + every metric, behind a spinner) is mounted only
// around the right-hand pane, which is the part that needs metric names.

const PanelDiv = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;
  min-width: 0;
`;

const EvalPanel = () => {
  const navigate = useNavigate();
  const { checkId } = useParams<{ checkId: string }>();
  const { checks } = useContext(AgentEvalContext);
  // Checks always run against the live KB now that the draft/live toggle is gone.
  const target: AgentEval.RunTarget = 'resolved';
  const [editing, setEditing] = useState<
    { mode: 'new' } | { mode: 'edit'; check: AgentEval.ListedCheck } | null
  >(null);

  const selected = checks.find((check) => check.id === checkId);

  return (
    <PanelDiv data-testid="agent-eval-panel">
      <EvalList
        selectedId={checkId}
        onSelect={(id) => {
          setEditing(null);
          navigate(`../checks/${id}`);
        }}
        onNewCheck={() => setEditing({ mode: 'new' })}
        target={target}
      />
      {editing ? (
        <AnalysisGate>
          <CheckEditor
            check={editing.mode === 'edit' ? editing.check : undefined}
            onDone={(saved) => {
              setEditing(null);
              if (saved) {
                navigate(`../checks/${saved.id}`);
              }
            }}
          />
        </AnalysisGate>
      ) : selected ? (
        <AnalysisGate>
          <EvalDetail
            check={selected}
            target={target}
            onEdit={() => setEditing({ mode: 'edit', check: selected })}
          />
        </AnalysisGate>
      ) : (
        <EvalDetailEmpty />
      )}
    </PanelDiv>
  );
};

export default EvalPanel;
